import classNames from 'classnames';
export default classNames('no-print position-absolute zindex-large', 'toolbar font-size-normal font-weight-normal border-shade-50', 'flexbox flexbox-align-center');